import Main from 'Components/Main/index.Main';
import { GlobalStyle } from 'Style/style';

const App = () => {
  return (
    <>
      <GlobalStyle />
      <Main />
    </>
  );
};

export default App;
